<div class="rounded-lg bg-[#F0F0F0] py-4 dark:bg-inherit md:p-4">
    <ion-accordion-group>
        <ul class="flex flex-col gap-4">
            <li
                class="bg-white p-4 shadow-sm dark:border dark:border-solid dark:border-contrast-yellow"
                *ngFor="let feedback of feedbackHistoryList">
                <p class="flex text-xs font-semibold uppercase text-grey-dark dark:text-contrast-yellow">
                    <span class="flex-1">
                        {{ feedback.requestDto.created_at | date: env.PRIMARY_DATE_FORMAT }}
                    </span>
                    <span
                        class="pn-app-light:text-white pn-app-light:bg-primary pn-light:text-primary pn-light:text-primary text-secondary">
                        {{ 'FEEDBACK_HISTORY_STATUS' | translate }}:
                        {{ feedback.requestDto.status.translation }}
                    </span>
                    <span class="flex-1 text-right">
                        {{ feedback.requestDto.created_at | date: 'HH:mm' }}
                    </span>
                </p>
                <hr class="my-3 border border-black opacity-10 dark:border-contrast-yellow dark:opacity-100" />
                <p class="flex flex-col">
                    <span class="mb-1 text-xs text-[#5E5E5E] dark:text-contrast-yellow">
                        {{ 'FEEDBACK_HISTORY_SENT_BY' | translate }}
                    </span>
                    {{ feedback.requestDto.name }}
                </p>
                <hr class="my-3 border border-black opacity-10 dark:border-contrast-yellow dark:opacity-100" />
                <p class="mb-2 font-semibold">{{ feedback.requestDto.category.translation }}</p>
                <p>{{ feedback.messageDetailDtos[0].message }}</p>
                <ng-container *ngFor="let attachment of feedback.messageDetailDtos[0].attachments">
                    <p class="mt-3 text-xs underline">{{ attachment }}</p>
                </ng-container>

                <ng-container *ngIf="feedback.messageDetailDtos.length > 1">
                    <hr class="mb-0 mt-3 border border-black opacity-10 dark:border-contrast-yellow dark:opacity-100" />
                    <ion-accordion>
                        <ion-item class="text-base" slot="header">
                            <p
                                class="pn-app-light:text-white pn-app-light:bg-primary pn-light:text-primary pn-light:text-primary py-4 text-xs font-semibold uppercase text-secondary">
                                {{ 'FEEDBACK_HISTORY_REPLIES' | translate }}
                                <span
                                    class="pn-app-light:text-white pn-app-light:bg-primary pn-light:bg-primary pn-light:bg-primary ml-1 rounded-full bg-secondary px-2 text-white dark:bg-contrast-black">
                                    {{ feedback.messageDetailDtos.length - 1 }}
                                </span>
                            </p>

                            <ion-icon
                                class="ion-accordion-toggle-icon m-0 text-lg text-secondary"
                                name="chevron-down-outline"
                                slot="end"
                                color="secondary">
                            </ion-icon>
                        </ion-item>

                        <ul class="flex flex-col gap-4" slot="content">
                            <li *ngFor="let reply of feedback.messageDetailDtos.slice(1)">
                                <div
                                    class="rounded-lg bg-[#F0F0F0] p-4 dark:border dark:border-solid dark:border-contrast-yellow dark:bg-inherit">
                                    <p
                                        class="flex justify-between text-xs font-semibold uppercase text-grey-dark dark:text-contrast-yellow">
                                        <span>
                                            {{ reply.created_at | date: env.PRIMARY_DATE_FORMAT }}
                                        </span>
                                        <span>
                                            {{ reply.created_at | date: 'HH:mm' }}
                                        </span>
                                    </p>

                                    <hr
                                        class="my-3 border border-black opacity-10 dark:border-contrast-yellow dark:opacity-100" />

                                    <p class="flex flex-col">
                                        <span class="mb-1 text-xs text-[#5E5E5E] dark:text-contrast-yellow">
                                            {{ 'FEEDBACK_HISTORY_SENT_BY' | translate }}
                                        </span>
                                        {{ reply.name }}
                                    </p>
                                    <hr
                                        class="my-3 border border-black opacity-10 dark:border-contrast-yellow dark:opacity-100" />
                                    <p>{{ reply.message }}</p>
                                </div>
                            </li>
                        </ul>
                    </ion-accordion>
                </ng-container>
            </li>
        </ul>
    </ion-accordion-group>
</div>
